import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { RequestStatus } from '@beef/smart-kit';
import { IMAGE_DATA } from 'constants/detalization';

// Styles
import styles from '../EmailForm/styles.pcss';

const cx = classNames.bind(styles);

export const SuccessSection = ({ onClick }) => (
  <RequestStatus
    img={{ ...IMAGE_DATA, className: cx('success-icon') }}
    title="Почта изменена"
    description="Адрес также будет отображаться в личном кабинете и будет использован для восстановления пароля"
    button={{
      text: 'К получению детализации',
      size: 'm',
      variant: 'main',
    }}
    onConfirm={onClick}
  />
);

SuccessSection.propTypes = {
  onClick: PropTypes.func,
};
